import { get,post,baseUrl,fileUrl,postFrom,postJson} from '@/ajax/http'
//公司申请
export const company_apply =(row) => postJson('seat/common/apply',{
    row:row
})


